import { useEffect, useState } from 'react';

import fetchService from '@xanadu/ui-shared/utils/fetchService';

let LOCALE_URL = '/edge/rest/locale';

const useLocalisedCountryData = () => {
  const [countryData, setCountryData] = useState({ countryName: '', currency: '' });
  const { countryName, currency } = countryData;
  let isMounted = true;

  const setCountryAutomatically = async () => {
    try {
      if (localStorage.getItem('mb-test-geo-hook') !== null) {
        LOCALE_URL = `/edge/rest/locale?ip=${localStorage.getItem('mb-test-geo-hook')}`;
      }

      const response = await fetchService(LOCALE_URL);

      if (isMounted && response.currency) {
        setCountryData({
          countryName: response.countryCode !== 'XX' && response.countryCode ? response.country : '',
          currency: response.currency,
        });
      }
    } catch (err) {
      const errorMessage = 'Error getting country data.';
      // eslint-disable-next-line no-console
      console.warn(errorMessage, err);
    }
  };

  useEffect(() => {
    setCountryAutomatically();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    countryName,
    currency
  };
};

export default useLocalisedCountryData;
